module.exports = __webpack_public_path__ + "static/media/jquery.cebb17c0.svg";